import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      // Authentication
      'auth.signIn': 'Sign In',
      'auth.signUp': 'Sign Up',
      'auth.email': 'Email',
      'auth.password': 'Password',
      'auth.confirmPassword': 'Confirm Password',
      'auth.firstName': 'First Name',
      'auth.lastName': 'Last Name',
      'auth.companyName': 'Company Name',
      'auth.signInButton': 'Sign In',
      'auth.signUpButton': 'Create Account',
      'auth.switchToSignUp': "Don't have an account? Sign up",
      'auth.switchToSignIn': 'Already have an account? Sign in',
      'auth.forgotPassword': 'Forgot password?',
      'auth.sendResetLink': 'Send Reset Link',
      'auth.resetPasswordSent': 'Password reset email sent! Check your inbox.',
      'auth.backToSignIn': 'Back to sign in',
      'auth.signOut': 'Sign Out',
      'auth.setNewPassword': 'Set New Password',
      'auth.setNewPasswordDescription': 'Enter your new password below',
      'auth.newPassword': 'New Password',
      'auth.confirmNewPassword': 'Confirm New Password',
      'auth.updatePassword': 'Update Password',
      'auth.passwordUpdated': 'Password updated successfully! Please sign in with your new password.',
      'auth.passwordMismatch': 'Passwords do not match',
      'auth.passwordTooShort': 'Password must be at least 6 characters',
      'auth.recoveryLinkExpired': 'Recovery link has expired. Please request a new one.',
      
      // Dashboard
      'dashboard.welcome': 'Welcome to Workforce',
      'dashboard.title': 'Dashboard',
      
      // Common
      'common.loading': 'Loading...',
      'common.error': 'Error',
      'common.success': 'Success',
      'common.cancel': 'Cancel',
      'common.save': 'Save',
      'common.delete': 'Delete',
      'common.edit': 'Edit',
      'common.view': 'View',
      
      // Navigation
      'nav.dashboard': 'Dashboard',
      'nav.team': 'Team',
      'nav.myTimesheets': 'My Timesheets',
      'nav.teamTimesheets': 'Team Timesheets',
      'nav.leave': 'Leave',
      'nav.leaveApprovals': 'Leave Approvals',
      'nav.schedulePlanner': 'Schedule Planner',
      'nav.mySchedule': 'My Schedule',
      'nav.payslips': 'My Payslips',
      'nav.employees': 'Employees',
      'nav.timesheets': 'Timesheets',
      'nav.schedule': 'Schedule',
      'nav.reports': 'Reports',
      'nav.settings': 'Settings',
      
      // Team Management
      'team.title': 'Team Management',
      'team.description': 'Manage your team members and invite new ones to join your company',
      'team.inviteButton': 'Invite Member',
      'team.inviteDialog.title': 'Invite Team Member',
      'team.inviteDialog.description': 'Send an invitation to a new team member to join your company',
      'team.inviteDialog.email': 'Email Address',
      'team.inviteDialog.emailPlaceholder': 'Enter email address',
      'team.inviteDialog.role': 'Role',
      'team.inviteDialog.rolePlaceholder': 'Select a role',
      'team.inviteDialog.sending': 'Sending...',
      'team.inviteDialog.send': 'Send Invitation',
      'team.roles.admin': 'Admin',
      'team.roles.manager': 'Manager',
      'team.roles.staff': 'Staff',
      'team.table.member': 'Team Member',
      'team.table.email': 'Email',
      'team.table.role': 'Role',
      'team.table.joinedDate': 'Joined Date',
      'team.table.noMembers': 'No team members found',
      'team.table.pendingName': 'Pending',
      
      // Time & Attendance
      'timeAttendance.title': 'Time & Attendance',
      'timeAttendance.description': 'Track your work hours with clock in and out',
      'timeAttendance.clockedIn': 'You are currently clocked in',
      'timeAttendance.clockedOut': 'You are currently clocked out',
      'timeAttendance.clockedInAt': 'Clocked in at',
      'timeAttendance.readyToStart': 'Ready to start your work day?',
      'timeAttendance.clockIn': 'Clock In',
      'timeAttendance.clockOut': 'Clock Out',
      'timeAttendance.clockingIn': 'Clocking In...',
      'timeAttendance.clockingOut': 'Clocking Out...',
      'timeAttendance.currentTime': 'Current time',
      'timeAttendance.myTimesheets': 'My Timesheets',
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;